import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { dashboardApiDetails, notificationApiDetails } from "../actions/auth";
import { categoryDetails } from "../actions/category";
import { backendImageUrl, RoutesPaths } from "../Router/constant";

export default function Dashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dashboardDetails, notificationDetails } = useSelector(
    (state) => state.auth,
  );
  const { categoryList } = useSelector((state) => state.category);
  const [page, setPage] = useState(1);
  const limit = 4;
  const totalPages = notificationDetails?.pagination?.totalPages || 1;

  useEffect(() => {
    dashboardApi();
    dispatch(categoryDetails("", 1, 10));
    dispatch(notificationApiDetails(page, limit));
  }, [page]);

  const dashboardApi = () => {
    dispatch(dashboardApiDetails());
  };

  const viewCategory = () => {
    navigate(RoutesPaths.CATEGORIES);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("sv-SE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const notificationColors = [
    {
      bg: "bg-light-warning",
      text: "text-warning",
    },
    {
      bg: "bg-light-success",
      text: "text-success",
    },
    {
      bg: "bg-light-danger",
      text: "text-danger",
    },
    {
      bg: "bg-light-info",
      text: "text-info",
    },
  ];

  const getPagination = (page, totalPages) => {
    const pages = [];

    // Always show first page
    pages.push(1);

    // Left dots
    if (page > 2) {
      pages.push("...");
    }

    // Current & next page
    if (page > 1 && page < totalPages) {
      pages.push(page);
    }

    if (page + 1 < totalPages) {
      pages.push(page + 1);
    }

    // Right dots
    if (page + 2 < totalPages) {
      pages.push("...");
    }

    // Always show last page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return [...new Set(pages)];
  };

  const notificationRedirect = (item) => {
    if (!item) return;

    switch (item.createdFor) {
      case "Store":
        // navigate(RoutesPaths.VIEWSTORS.replace(":id", item._id));
        navigate(RoutesPaths.VIEWSTORS.replace(":id", item.storeId));
        break;

      case "User":
        navigate(RoutesPaths.USERS);
        break;

      case "category":
        navigate(RoutesPaths.CATEGORIES);
        break;

      default:
        console.warn("Unknown notification type:", item.createdFor);
        break;
    }
  };
  const redirect = (type) => {
    switch (type) {
      case "USERS":
        navigate("/users");
        break;
      case "CATEGORIES":
        navigate("/category");
        break;
      case "STORS":
        navigate("/stors");
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="container-fluid mainConatinerSection">
        <div className="row g-5 g-xl-8">
          <div className="col-xl-4" onClick={() => redirect("USERS")}
            style={{ cursor: "pointer" }}>
            <div className="card card-xl-stretch mb-5 mb-xl-8 customCardSection">
              <div className="card-body p-9 greeCardSection">
                <div className="dasboaardCarddetails">
                  <h6>Our users</h6>
                  <p>
                    Displays the total number of users created in the system.
                  </p>
                </div>
                <div>
                  <h1 className="totalNumber greentext m-0">
                    {dashboardDetails?.data?.counts?.users}
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-4" onClick={() => redirect("CATEGORIES")}
            style={{ cursor: "pointer" }}>
            <div className="card card-xl-stretch mb-5 mb-xl-8 customCardSection">
              <div className="card-body p-9 redCardSection">
                <div className="dasboaardCarddetails">
                  <h6>Our categories</h6>
                  <p>Shows the number of categories currently created.</p>
                </div>
                <div>
                  <h1 className="totalNumber redtext m-0">
                    {dashboardDetails?.data?.counts?.categories}
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-4" onClick={() => redirect("STORS")}
            style={{ cursor: "pointer" }}>
            <div className="card card-xl-stretch mb-5 mb-xl-8 customCardSection">
              <div className="card-body p-9 purpalCardSection">
                <div className="dasboaardCarddetails">
                  <h6>Our stores</h6>
                  <p>
                    Indicates how many stores have been created on the platform.
                  </p>
                </div>
                <div>
                  <h1 className="totalNumber purpalText m-0">
                    {dashboardDetails?.data?.counts?.stores}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-5 g-xl-8">
          <div className="col-xl-6">
            <div className="card card-xl-stretch mb-xl-8">
              <div className="card-header align-items-center border-0 mt-4">
                <h3 className="card-title align-items-start flex-column">
                  <span className="fw-bold text-gray-900">Latest categories</span>
                  <span className="text-muted mt-1 fw-semibold fs-7">
                    Articles and publications
                  </span>
                </h3>
                <div className="card-toolbar">
                  <button
                    type="button"
                    className="btn viewCategoryIcon"
                    onClick={viewCategory}
                  >
                    View categories
                  </button>
                </div>
              </div>
              <div className="card-body pt-3">
                {categoryList?.data?.slice(0, 6).map((item, index) => (
                  <div className="d-flex mb-7" key={index}>
                    <div className="symbol symbol-60px symbol-2by3 me-4">
                      <div
                        className="symbol-label"
                        style={{
                          backgroundImage: `url(${backendImageUrl + item?.icon?.fileName
                            })`,
                        }}
                      ></div>
                    </div>
                    <div className="d-flex flex-row-fluid flex-wrap align-items-center">
                      <div className="flex-grow-1 me-2">
                        <span className="fw-bold text-gray-800 fs-6">
                          {item.name}
                        </span>
                        <span className="text-muted fw-semibold d-block pt-1 twoLineShow">
                          {item.description}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="card card-xl-stretch mb-5 mb-xl-8">
              <div className="card-header border-0">
                <h3 className="card-title fw-bold text-gray-900">
                  Notifications
                </h3>
              </div>
              <div className="card-body pt-0">
                {notificationDetails?.data?.map((item, index) => {
                  const color =
                    notificationColors[index % notificationColors.length];

                  return (
                    <div
                      key={index}
                      className={`d-flex align-items-center ${color.bg} rounded p-5 mb-5`}
                      onClick={() => notificationRedirect(item)}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className={`ki-duotone ki-abstract-26 ${color.text} fs-1 me-5`}
                      >
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </i>

                      <div className="flex-grow-1 me-2">
                        <span className="fw-bold text-gray-800 fs-6">
                          {item?.title}
                        </span>
                        <span className="text-muted fw-semibold d-block">
                          {item?.message}
                        </span>
                        <span className={`fw-bold ${color.text} py-1`}>
                          {formatDate(item.createdAt)}
                        </span>
                      </div>
                    </div>
                  );
                })}

                {/* Pagination */}
                <div className="row mt-4">
                  <div className="col-md-3">
                    <strong>
                      Total: {notificationDetails?.pagination?.total}
                    </strong>
                  </div>

                  <div className="col-md-9 d-flex justify-content-end">
                    <ul className="pagination">
                      {/* Prev */}
                      {page > 1 && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => setPage(page - 1)}
                          >
                            Prev
                          </button>
                        </li>
                      )}

                      {getPagination(page, totalPages).map((item, index) => (
                        <li
                          key={index}
                          className={`page-item ${item === page ? "activePagination" : ""
                            } ${item === "..." ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            disabled={item === "..."}
                            onClick={() => item !== "..." && setPage(item)}
                          >
                            {item}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      {page < totalPages && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => setPage(page + 1)}
                          >
                            Next
                          </button>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                {/* End Pagination */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
